import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";

import FontIcon from "material-ui/FontIcon";
import IconMenu from "material-ui/IconMenu";
import MenuItem from "material-ui/MenuItem";
import IconButton from "material-ui/IconButton";
import FlatButton from "material-ui/FlatButton";
import AccountBalanceWallet from "material-ui/svg-icons/action/account-balance-wallet";
import PersonIcon from "material-ui/svg-icons/social/person";
import BusinessCenterIcon from "material-ui/svg-icons/places/business-center";
import { PopoverAnimationVertical } from "material-ui/Popover";
import { Toolbar, ToolbarGroup } from "material-ui/Toolbar";
import BalanceInfo from "components/Balance/BalanceInfo";
import MessageInfo from "components/Balance/MessageInfo";
import { TOGGLE_LEFT } from "data/menus/types";

import MenuLink from "components/Navigation/MenuLink";
import LogoutMenuItem from "components/Auth/LogoutMenuItem";
import { menus } from "data/actions";
const style = {
  color: "rgba(255, 255, 255,0.8)",
  backgroundColor: "#0288d1",
  logo: {
    maxHeight: 40,
    marginTop: 10,
    marginLeft: -20,
    opacity: "0.9"
  }
};

const MenuButton = ({ label, to }) => (
  <FlatButton style={style} label={label} containerElement={<Link to={to} />} />
);

class Menu extends Component {

  onClick = (event) =>{
    if (event.target.tagName !== 'DIV')
    {
      this.props.actions.closeLeft(false);
    }
  }

  render() {
    var cls = this.props.authed ? "menu menu__authed" : "menu ";
    cls += this.props.showMenu ? " menu--open " : "";

    return (
      <nav id="nav" className={cls} role="navigation">
        <a className="close" onClick={this.props.actions.closeLeft}>
          ×
        </a>
        <div className="menu__list" onClick={this.onClick}>
          <Link to="/">
            <img alt="" style={style.logo} src="/images/logo.png" />
          </Link>
          {this.props.authed
            ? [
                <Link to="/medier" key="medier">
                  Mediebokaren
                </Link>,
                <Link to="/kampanj" key="kampanj">
                  Kampanjer
                </Link>,
                <Link to="/rapporter" key="rapporter">
                Rapporter
              </Link>,
              <div key="sep" className="menu__separator" />,
                <Link to="/transaktioner" key="transaktioner">
                  {<BalanceInfo accountid={this.props.user.accountid} />}
                </Link>,
                <Link to="/meddelanden" key="meddelanden" className="message-info-link">
                  {<MessageInfo accountid={this.props.user.accountid} />}
                </Link>
              ]
            : null}

          {this.props.authed && (
            <IconMenu
              useLayerForClickAway
              desktop={true}
              animation={PopoverAnimationVertical}
              iconButtonElement={
                <IconButton>
                  <PersonIcon color={style.color} />
                </IconButton>
              }
              anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
              targetOrigin={{ horizontal: "left", vertical: "top" }}
            >
              <MenuItem>
                <MenuLink label="Konto" to="/profile" />
              </MenuItem>
              <MenuItem>
                <MenuLink label="Transaktioner" to="/transaktioner" />
              </MenuItem>
              <MenuItem>
                <MenuLink label="Fakturor" to="/fakturor" />
              </MenuItem>
              <MenuItem>
                <LogoutMenuItem />
              </MenuItem>
            </IconMenu>
          )}

          {this.props.user &&
            this.props.user.role === "admin" && (
              <IconMenu
                useLayerForClickAway
                desktop={true}
                animation={PopoverAnimationVertical}
                iconButtonElement={
                  <IconButton>
                    <BusinessCenterIcon color={style.color} />
                  </IconButton>
                }
                anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
                targetOrigin={{ horizontal: "left", vertical: "top" }}
              >
                <MenuItem>
                  <MenuLink label="Mediehus" to="/admin/mediagroups" />
                </MenuItem>
                <MenuItem>
                  <MenuLink label="Medier" to="/admin/brands" />
                </MenuItem>
                <MenuItem>
                  <MenuLink label="Kanaler" to="/admin/categories" />
                </MenuItem>
                <MenuItem>
                  <MenuLink label="Segment" to="/admin/segments" />
                </MenuItem>
                <MenuItem>
                  <MenuLink label="Produkter" to="/admin/products" />
                </MenuItem>
                <MenuItem>
                  <MenuLink label="Produkttyper" to="/admin/producttypes" />
                </MenuItem>
                <MenuItem>
                  <MenuLink label="Leverantörer" to="/admin/providers" />
                </MenuItem>
                <MenuItem>
                  <MenuLink label="Personer" to="/admin/persons" />
                </MenuItem>
                <MenuItem>
                  <MenuLink label="Bokningar" to="/admin/orders" />
                </MenuItem>
                <MenuItem>
                  <MenuLink label="Konton" to="/admin/accounts" />
                </MenuItem>
                <MenuItem>
                  <MenuLink label="Användare" to="/admin/users" />
                </MenuItem>
              </IconMenu>
            )}
        </div>
      </nav>
    );
  }
}

function mapStateToProps(state) {
  return {
    showMenu: state.menus && state.menus.open === TOGGLE_LEFT
  };
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators({ ...menus }, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatch)(Menu);



// WEBPACK FOOTER //
// ./src/pages/Menu.jsx